import { ClaimAssigneeRelationshipCanon } from '@eigtech/assignments-types'
import { startCase } from 'lodash-es'

const assignmentLabels: Partial<Record<ClaimAssigneeRelationshipCanon, string>> = {
  policyHolder: 'Policyholder',
}

export const getContactAssignmentLabel = (role: string | ClaimAssigneeRelationshipCanon) =>
  assignmentLabels[role as ClaimAssigneeRelationshipCanon] || startCase(role)
